import type { ReactNode } from 'react'

function ProjectCellContainer({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col h-30 justify-center gap-2">{children}</div>
  )
}

export { ProjectCellContainer }
